import React, { useEffect } from 'react';
import HeroStyle2 from '../../Hero/HeroStyle2';
import Section from '../../Section';
import AboutSectionStyle3 from '../../Section/AboutSection/AboutSectionStyle3';
import WorkingProcess from '../../Section/WorkingProcess';
import BannerSectionStyle2 from '../../Section/BannerSection/BannerSectionStyle2';
import AppointmentSectionStyle2 from '../../Section/AppointmentSection/AppointmentSectionStyle2';
import generalvideo from "../../Images/generalvideo.mp4"
import { pageTitle } from '../../../helpers/PageTitle';
import FunFactSection from '../../Section/FunFactSection';
import funfact from "../../Images/funfact.jpeg";
import ecommercebg2 from "../../Images/bg/ecommercebg2.jpg";
import about from "../../Images/about.png";
import a23 from "../../Images/a23.jpg";
import a2 from "../../Images/a2.png";

const testimonialData = [
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '4.5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '4.5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
];
const workingProcessData = [
    {
        title: 'Convenience',
        subTitle:
            'You will never have to inconvenience yourself by having to purchase and transport around. Online purchase allows you to purchase more items and get it delivered right to your door step. In addition, most online stores on platform operate 24 hours a day, which means you can place your order at any time throughout the day.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_1.svg',
        number: '01',
    },
    {
        title: 'Lower Prices and Discounts',
        subTitle:
            'Online prices are more transparent than physical stores as consumers are able to compare across a large range of sellers. Retailers are also able to charge a lower cost as managing an online shop has significantly lower fixed cost than traditional retailers. Furthermore, online stores frequently offer special deals and discounts which ranges from flat discounts of 20% to free delivery services.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_2.svg',
        number: '02',
    },
    {
        title: 'Quality',
        subTitle:
            'With regards to medical supplies, quality is extremely important. A disregard of quality for medical supplies may have a severe impact on the life of the patient involved. Ensure you do your own due diligence by reading the product specifications and descriptions carefully to ensure that there is no room for disputes. Also, try to look for an online store which offers products from trusted vendors and reputable manufacturers that are well-known in the medical industry.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_3.svg',
        number: '03',
    },
    {
        title: 'Replacement & Refund Policies',
        subTitle:
            'Ensure that the website has thorough replacement and refund policies for defective products. For medical products which are usually expensive, being sold a damaged or defective product could mean significant losses.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_4.svg',
        number: '04',
    },
];
const blogData = [
    {
        title: 'The Benefits of Mindfulness Meditation for Stress and Anxiety',
        thumbUrl: 'images/home_1/post_1.jpeg',
        date: 'May 1, 2023',
    },
    {
        title: 'Healthy Eating on a Budget: Tips and Strategies',
        thumbUrl: 'images/home_1/post_2.jpeg',
        date: 'May 4, 2023',
    },
    {
        title: 'The Importance of Regular Cancer Screenings and Early Detection',
        thumbUrl: 'images/home_1/post_3.jpeg',
        date: 'May 1, 2023',
    },
];
const faqData = [
    {
        title: 'What services does ProHealth offer?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'How do I schedule an appointment with ProHealth?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'Do you accept insurance?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'What should I bring to my appointment?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'How do I request a prescription refill?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
];
const brandData = [
    {
        imgUrl: '/images/brand_1.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_2.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_3.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_4.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_5.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_6.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_7.png',
        imgAlt: 'Brand',
    },
];
const funFactData = [
    { number: '15+', title: 'Years of experience' },
    { number: '1.6 Cr', title: 'Patient Registration' },
    { number: '700000+', title: 'Transactions per day.' },
    { number: '300+', title: 'Hospitals,Diagnostic Centers and Pharmacies Customers' },
    { number: '5+', title: 'Countries Customers' },
];

export default function ECommerce() {
    pageTitle('Home V2');

    // Preload the background image for faster loading
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = ecommercebg2;
        link.fetchPriority = 'high';
        document.head.appendChild(link);

        // Also preload the image in browser cache
        const img = new Image();
        img.src = ecommercebg2;

        return () => {
            if (document.head.contains(link)) {
                document.head.removeChild(link);
            }
        };
    }, []);

    return (
        <>
            <HeroStyle2
                title="E-Commerce Solutions"
                subTitle="The online healthcare scene has been growing exponentially due to increased
                 internet penetration and usage of mobile/internet apps. Medical applications like telemedicine,
                  caregiving services and medical consultation are some of the new innovations in the healthcare
                   sector which is revolutionizing the entire healthcare system."
                bgUrl={ecommercebg2}
                imgUrl={process.env.PUBLIC_URL + "/images/home_2/patents.png"}
            // btnText="Doc Choice"
            // btnUrl="/"
            />
            <Section topMd={175} topLg={125} topXl={85}>
                <FunFactSection
                    bgUrl={funfact}
                    data={funFactData}
                />
            </Section>

            <Section
                topMd={185}
                topLg={140}
                topXl={100}
                bottomMd={200}
                bottomLg={150}
                bottomXl={110}
            >
                <WorkingProcess
                    sectionTitle="Medna Data Systems has a robust platform which helps patients in following ways"
                    sectionTitleUp=""
                    sectionTitleDown=""
                    data={workingProcessData}
                />
            </Section>
            <Section>
                <BannerSectionStyle2
                    bgUrl={a23}
                    title="Don’t Let Your Hospital <br />Take a Backseat!"
                    subTitle="Schedule an demo with one of our experienced <br />professionals today!"
                />
            </Section>
            {/* <Section topMd={190} topLg={145} topXl={105}>
        <BlogSectionStyle3
          sectionTitle="Latest Update"
          sectionTitleUp="BLOG POSTS"
          sectionTitleDown=""
          sectionSubTitle=""
          data={blogData}
        />
      </Section> */}
            <Section bottomMd={190} bottomLg={145} bottomXl={105}>
                <AboutSectionStyle3
                    titleUp="Decades of expertise and market leadership. A distinguished history of 
          innovative Healthcare Solutions."
                    title="Meet The Minds Behind Medna Data Systems"
                    subTitle="Building compliant, scalable healthcare technology for the UAE.
Medna Data Systems is a healthcare technology company focused on delivering a robust, 
regulatory-ready Healthcare ERP and HMIS platform for clinics and hospitals operating in the UAE.
We bring together deep technical expertise, healthcare domain knowledge, and real-world implementation
 experience to solve one core problem: making healthcare operations simpler, compliant, and efficient
  without compromising patient data or clinical workflows."
                    imgUrl={about}
                />
            </Section>

            <Section>
                <AppointmentSectionStyle2
                    bgUrl={process.env.PUBLIC_URL + "/images/home_2/appointment_bg.svg"}
                    imgUrl={a2}
                    sectionTitle="Appointment"
                    sectionTitleUp="BOOK AN"
                />
            </Section>
            {/* <Section
                topMd={200}
                topLg={150}
                topXl={110}
                bottomMd={200}
                bottomLg={150}
                bottomXl={110}
            >
                <BrandsSectionStyle2 data={brandData} />
            </Section> */}
        </>
    );
}
